export default __webpack_public_path__ + "static/media/WhitneySSm-Black-Adv_Web.155ea73b.woff2";